import React, { Component, isValidElement } from "react";
import { Segment, Icon, Button, Label } from "semantic-ui-react";
import { terbilang } from "../../../../../_utils/terbilang";
import { toIDR } from "../../../../../_utils/tocurrency";
import Barcode from "react-barcode";
import { toDMYDate } from "../../../../../_utils/convert_datetime";
import printJS from "print-js";
import { isBank, isAdmin, isVerificator } from "../../../../../_utils/localstorage";
import swal from "sweetalert";
import { BaseURLDev, headers } from "../../../../../_utils/config";

export default class PrintSTS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data_detail
    };
  }
  exportData() {
    printJS({
      printable: "data_print",
      type: "html",
      modalMessage: "Sedang memuat data...",
      showModal: true,
      maxWidth: "1300",
      font_size: "8pt",
      documentTitle: "Print STS",
      targetStyles: ["*"],
      ignoreElements: ['status', 'checkHeading', 'checkRow']
    });
  }

  verifikasiUlangSTS(no_sts){
      
    swal({
       title: "Apakah anda yakin?",
       text: "STS ini akan diverifikasi ulang dan langsung divalidasi ke server SIMDA!",
       icon: "warning",
       buttons: true,
       dangerMode: true,
    })
    .then((verif) => {
       if (verif) {
          this.setState({requests:true});
          fetch(`${BaseURLDev}/postsimda/verifikasibpkad`,{
             method: 'POST',
             headers,
             body: JSON.stringify({
                no_sts: no_sts,
                date: null
             })
          })
          .then(response => {
             if (!response.ok) { 
                this.setState({requests:false});
                swal("Verifikasi STS gagal", {
                   icon: "error",
                });
                return Promise.reject(response.statusText);
             }
             return response.json()
          })
          .then(parsedJSON => {
             this.setState({
                // data:{
                //    ...this.state.data,
                //    is_verified: true
                // },
                requests: false
             });
             swal("Verifikasi STS selesai", {
                icon: "success",
             }).then(()=>{
                window.location.href="/a/sts"
             });
          })
       } else {
          return false
       }
    });
 }
 
  // checkRincianSTS(public_id) {
  //   // fetch(`${BaseURLDev}/postsimda/check_rincian_sts`, { headers })
  //   fetch(`${BaseURLDev}/postsimda/check_rincian_sts/${public_id}`, { headers })
  //     .then(response => {
  //       if (!response.ok) {
  //         swal("Load data gagal", { icon: "error" });
  //         // this.setState({data: [], requests: false});
  //         return Promise.reject(response.statusText);
  //       }
  //       return response.json();
  //     })
  //     .then(resJSON => {
  //       console.log(resJSON.data.data, "lalal");
  //     }) //this.defaultState(resJSON))
  //     .catch(e => {
  //       // this.setState({
  //       //     requests:false,
  //       // })
  //       swal(
  //         "Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server",
  //         {
  //           icon: "error"
  //         }
  //       );
  //     });
  // }

  render() {
    const styletb = {
      borderCollapse: "collapse",
      borderSpacing: 0,
      borderStyle: "solid",
      width: "97%",
      fontSize: "12px"
    };

    const { data } = this.state;
    var count = 0;
    var counter = 0;

    if (data !== null) {
      data.bp.map((item, i) =>
        item.rincian.map((rek, ii) => (count = count + rek.nilai))
      );
    }

    return (
      <div>
        {/* {!isBank() && ( */}
          <Button color="blue" size="small" onClick={() => this.exportData()}>
            <p>
              <Icon name="print" className="left floated" />
              Preview
            </p>
          </Button>
        {/* )}
        {((isAdmin() || isVerificator()) && data["is_verified"]) && (
          <Button
            color="green"
            size="small"
            onClick={() => this.verifikasiUlangSTS(data["no_sts"])}
          >
            <p>
              <Icon name="print" className="left floated" />
              Verifikasi Ulang
            </p>
          </Button>
        )} */}
        <br />
        <br />
        <div ref={el => (this.componentRef = el)}>
          <Segment>
            <div id="data_print">
              <div className="barcode" align="right">
                <Barcode
                  value={data["no_sts"]}
                  height={40}
                  fontSize={13}
                  width={1}
                />
              </div>
              <table align="center" width="100%" style={{ fontSize: "12px" }}>
                <tbody>
                  <tr align="center">
                    <th colSpan="2">
                      <p style={{ marginBottom: "25px" }}>
                        PEMERINTAH PROVINSI NUSA TENGGARA BARAT
                        <br />
                        SURAT TANDA SETORAN (STS)
                      </p>
                    </th>
                  </tr>
                </tbody>
              </table>
              <table align="center" width="100%" style={{ fontSize: "12px" }}>
                <tbody>
                  <tr>
                    <td className="txt-left" width="30%">
                      Nomor STS
                    </td>
                    <td className="txt-left" align="left">
                      &nbsp;:&nbsp;{data["no_sts"]}
                    </td>
                  </tr>
                    { data['rekening_bank'] ?
                        <tr>
                          <td width="30%">{ data['rekening_bank']['nama_bank'] } - ({ data['rekening_bank']['nama_akun'] })</td>
                          <td className="txt-left" align="left">
                            &nbsp;:&nbsp;{ data['rekening_bank']['kode_akun'] }
                          </td>
                        </tr>
                    :
                      <tr>
                        <td width="30%">BANK NTB SYARIAH</td>
                        <td className="txt-left" align="left">
                          &nbsp;:&nbsp;00121 05807 006
                        </td>
                      </tr>
                    }
                  <tr>
                    <td width="30%">Harap diterima uang</td>
                    <td className="txt-left" align="left">
                      &nbsp;:&nbsp;
                      {toIDR(count)}
                    </td>
                  </tr>
                  <tr>
                    <td width="30%">Terbilang</td>
                    <td className="txt-left" align="left">
                      &nbsp;:&nbsp;{terbilang(count)}
                    </td>
                  </tr>
                  <tr>
                    <td width="30%">Keterangan</td>
                    <td className="txt-left" align="left">
                      &nbsp;:&nbsp;{data['keterangan']}
                    </td>
                  </tr>
                  {/* { (isAdmin() || isVerificator()) &&
                    !data.status_sts ?
                        <tr id={'status'}>
                          <td width="30%">Status</td>
                          <td className="txt-left" align="left">
                            &nbsp;:&nbsp; <Label color="red" size="small">STS tidak terdaftar di SIMDA</Label>
                          </td>
                        </tr>
                        :
                        null
                  } */}
                  <tr>
                    <td colSpan="2">
                      <i>Dengan rincian penerimaan sebagai berikut</i> :
                    </td>
                  </tr>
                </tbody>
              </table>

              <table border="1" align="center" style={styletb} width="65%">
                <tbody>
                  <tr
                    align="left"
                    style={{ background: "#e5e5e5", padding: "4px" }}
                  >
                    {/* {(isAdmin() || isVerificator()) &&
                    <th id={'checkHeading'} width="4%" style={{ padding: "2px" }} align="center">
                      Status
                    </th>} */}
                    <th width="5%" style={{ padding: "4px" }}>
                      No.
                    </th>
                    <th width="10%" style={{ padding: "4px" }}>
                      Rekening
                    </th>
                    <th width="30%" style={{ padding: "4px" }}>
                      Uraian
                    </th>
                    <th width="20%" style={{ padding: "4px" }} align="right">
                      Jumlah (Rp.)
                    </th>
                  </tr>
                  {data.bp.map((item, i) =>
                    item.rincian.map((rek, ii) => {
                      // console.log(rek)
                      counter = counter + 1;
                      return (
                        <tr key={counter}>
                          {/* {(isAdmin() || isVerificator()) &&
                            <td id={'checkRow'} style={{ padding: "2px" }} width="2%" align="center">
                              {
                                rek.checkStatusSimda ?
                                    <Icon name="check" color={'green'} className="center" />
                                    :
                                    <Icon name="close" color={'red'} className="center" />
                              }
                            </td>
                          } */}
                          <td style={{ padding: "4px" }} width="5%">
                            {counter}.
                          </td>
                          <td
                            style={{ padding: "4px" }}
                            width="15%"
                          >{`${rek.kd_rek_1}.${rek.kd_rek_2}.${rek.kd_rek_3}.${rek.kd_rek_4}.${rek.kd_rek_5}.${rek.kd_rek_6}`}</td>
                          <td style={{ padding: "4px" }} width="60%">
                            <p>{rek.uraian_rinc}</p>
                            {/*<p>{ item.uraian }</p>*/}
                          </td>
                          <td
                            style={{ padding: "4px" }}
                            width="25%"
                            align="right"
                          >
                            {toIDR(rek.nilai)}
                          </td>
                        </tr>
                      );
                    })
                  )}
                  <tr style={{ background: "#e5e5e5" }}>
                    <td style={{ padding: "4px" }} colSpan="5" align="right">
                      {toIDR(count)}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                width="80%"
                style={{ marginTop: "10px", fontSize: "12px" }}
              >
                <tbody>
                  <tr align="left">
                    <td colSpan="2">
                      Diterima pada : {toDMYDate(data.tgl_sts)}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table
                align="center"
                width="80%"
                style={{ marginTop: "15px", fontSize: "12px" }}
              >
                <tbody>
                  <tr align="center">
                    {!data.is_terwakili ?
                      <td>
                        Mengetahui, <br />
                        {/*Pengguna Anggaran/Kuasa Pengguna Anggaran<br />*/}
                        {data.kuasa ? data.kuasa.jabatan : ""}
                      </td>
                    :
                      <td>
                        Mengetahui, <br />
                        {/*Pengguna Anggaran/Kuasa Pengguna Anggaran<br />*/}
                        a.n. {data.kuasa ? data.kuasa.jabatan : ""}<br />
                        {data.mewakili.jabatan_mewakili}
                      </td>
                    }
                    <td>
                      {/*Bendahara Penerima/Pembantu<br />*/}
                      {data.paraf ? data.paraf.jabatan : ""}
                    </td>
                  </tr>
                  <tr align="center">
                    {!data.is_terwakili ?
                      <td>
                        <br />
                        <br />
                        <br />
                        <u>{data.kuasa ? data.kuasa.nama : ""}</u>
                        <br />
                        {data.kuasa ? data.kuasa.kode : ""}
                        <br />
                      </td>
                    :
                      <td>
                        <br />
                        <br />
                        <br />
                        <u>{data.mewakili.nama_mewakili}</u>
                        <br />
                        {data.mewakili.nip_mewakili}
                        <br />
                      </td>
                    }
                    <td>
                      <br />
                      <br />
                      <br />
                      <u>{data.paraf.nama}</u>
                      <br />
                      {data.paraf ? data.paraf.kode : ""}
                      <br />
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />
              <div style={{ fontSize: "8pt" }}>
                Catatan : STS dilampiri Slip Setoran Bank
              </div>
              <div>
                <style>
                  {`@media print {
                            .table-footer tr td {
                                font-size: 8pt;
                                padding:0px;
                                text-align:left;
                            }

                            .txt-left{
                                text-align:left;
                                padding:0px;
                            }

                            }`}
                </style>
                <table
                  className="table-footer"
                  width="100%"
                  style={{ fontSize: "8pt" }}
                >
                  <tbody>
                    <tr align="left">
                      <td align="left">
                        Lembar 1 : Untuk BKP Unit Yang Bersangkutan
                      </td>
                      <td className="txt-left" align="left">
                        Lembar 4
                      </td>
                    </tr>
                    <tr align="left">
                      <td className="txt-left" align="left">
                        Lembar 2 : Untuk BAPPENDA Prov. NTB
                      </td>
                      <td className="txt-left" align="left">
                        Lembar 5
                      </td>
                    </tr>
                    <tr align="left">
                      <td className="txt-left" align="left">
                        Lembar 3 : Unit Pemegang Kas Daerah
                      </td>
                      <td className="txt-left" align="left">
                        Lembar 6
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Segment>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_sts/PrintSTS.js